import BaseFormation from "./BaseFormation";
import TreasurePickup from "../pickup/TreasurePickup";
import Game from "../Game";
import PickupType from "../../enums/PickupType";
import EnemyGroup from "../enemy/EnemyGroup";

export default class TreasureFormation extends BaseFormation {
  private treasure: TreasurePickup;

  protected createFormation(): void {
    // Create treasure chest at center
    this.treasure = Game.Core.MakePickup(
      this.centerX,
      this.centerY,
      PickupType.TREASURE
    ) as TreasurePickup;

    this.treasure.SetTreasureConfig();

    // Find or create enemy pool
    let enemyPool = Game.Core.Stage.pools.find(
      (p) => p.enemyType === this.config.enemyType
    );
    if (!enemyPool) {
      enemyPool = new EnemyGroup(Game.Core.scene, this.config.enemyType);
      enemyPool.Init(this.config.enemyType);
    }

    // Create circling enemies
    for (let i = 0; i < this.config.enemyCount; i++) {
      const angle = (i * Math.PI * 2) / this.config.enemyCount;
      const x = this.centerX + Math.cos(angle) * this.config.radius;
      const y = this.centerY + Math.sin(angle) * this.config.radius;

      const enemy = enemyPool.SpawnAt(x, y);

      if (enemy) {
        enemy.setInFormation(true);
        enemy.isCullable = false;
        this.enemies.push(enemy);
      }
    }
  }

  public update(): void {
    if (!this.treasure || this.treasure.active === false) {
      this.destroy();
      return;
    }
    super.update();
  }
}
